export default "__VITE_ASSET__77ea22a4__"